import { flattenTree } from '@/common/utils/ways';
import { deepCopy, refactorSelection } from '@lhb/func';
// import { sectionKey } from 'src/views/youth/pages/map/ts-config';

/** 商圈筛选类型-全部，见 src/views/youth/pages/map/ts-config.ts 的 useLeftSection */

/** 商圈筛选类型-商场型 */
export const useFilterTypeMallLeftSelection = ({ selection }: {
  /** 商场型筛选项，如
   * [
      {
        "name": "商场定位",
        "code": "mallPosition",
        "children": [
          { "name": "商场等级", "code": "projectLevel", "children": [ { "name": "S级", "code": "1", "children": null }, { "name": "A级", "code": "2", "children": null }, { "name": "B级", "code": "3", "children": null }, { "name": "C级", "code": "4", "children": null }, { "name": "D级", "code": "5", "children": null }] },
          { "name": "商场档次", "code": "projectGrade", "children": [ { "name": "高档", "code": "1", "children": null }, { "name": "中高档", "code": "2", "children": null }, { "name": "中档", "code": "3", "children": null }, { "name": "大众化", "code": "4", "children": null } ]
          }
        ]
      }
    ]
   */
  selection: any[],
}) => {
  // 转换为 label、code、children
  const _selection = refactorSelection(
    Array.isArray(selection) ? deepCopy(selection) : [],
    { name: 'name', id: 'code' },
    true,
    { label: 'label', value: 'code' },
  );

  return _selection;
};

/**
 * 获取商场型筛选右侧列表选项映射表，取自 selection.mallSelections 的二级选项
 * @description
 * @param {*} mallSelections
 * @return {*}
 * @demo
[
  {
    'name': '商场定位',
    'code': 'mallPosition',
    'children': [
      {
        'name': '商场等级',
        'code': 'projectLevel',
        'children': [{ 'name': 'S级', 'code': '1', 'children': null }, { 'name': 'A级', 'code': '2', 'children': null }, { 'name': 'B级', 'code': '3', 'children': null }, { 'name': 'C级', 'code': '4', 'children': null }, { 'name': 'D级', 'code': '5', 'children': null }]
      }
    ]
  }
]
=>
{
  'projectLevel': {
    'name': '商场等级',
    'code': 'projectLevel',
    'children': [{ 'name': 'S级', 'code': '1', 'children': null }, { 'name': 'A级', 'code': '2', 'children': null }, { 'name': 'B级', 'code': '3', 'children': null }, { 'name': 'C级', 'code': '4', 'children': null }, { 'name': 'D级', 'code': '5', 'children': null }]
  }
};
 */
export const getMallSelectionFlattenMap = (mallSelections) => {
  // 从 mallSelections 中提取所有二级选项
  const arr = (Array.isArray(mallSelections) ? mallSelections : []).flatMap(item => item.children || []);

  return flattenTree(arr, {
    valueKey: 'code',
    filter: item => item && Array.isArray(item.children) && item.children.length, // 过滤掉没有子项的项
  });
};

